export const GraphColors = [
  '#6dc7bb',
  '#FF6F61', // Coral
  '#6B5B95', // Deep Purple
  '#B565A7', // Medium Purple
  '#92A8D1', // Cool Blue
  '#55B4B0', // Soft Turquoise
  '#88B04B', // Moss Green
  '#F7CAC9', // Soft Pink
  '#955251', // Mauve Red
  '#009B77', // Teal Green
  '#DD4124', // Rust Red
  '#45B8AC', // Aqua
  '#EFC050', // Golden Yellow
  '#5B5EA6', // Indigo Blue
  '#9B2335', // Berry Red
  '#DFCFBE', // Sand Beige
  '#E15D44', // Brick Orange
  '#7FCDCD', // Light Cyan
  '#BC243C', // Deep Rose
  '#98B4D4', // Periwinkle
  '#C3447A', // Pink Magenta
  '#F4A460', // Sandy Brown
  '#4682B4', // Steel Blue
  '#D2691E', // Chocolate Brown
  '#FF4500', // Bright Orange
  '#8A2BE2', // Blue Violet
  '#DC143C', // Crimson Red
  '#00CED1', // Dark Turquoise
  '#20B2AA', // Light Sea Green
  '#FFD700', // Gold
  '#32CD32', // Lime Green
  '#8B4513', // Saddle Brown
  '#FF1493', // Deep Pink
  '#00FA9A', // Medium Spring Green
  '#9370DB', // Medium Purple
  '#3CB371', // Medium Sea Green
  '#DAA520', // Goldenrod
  '#C71585', // Medium Violet Red
  '#468499', // Cool Gray Blue
]

export const MapLayersColours = {
  specific: {
    'botulism (BoNT/A)': '#6dc7bb',
    'botulism (BoNT/AB)': '#6B5B95', // Deep Purple,
    'botulism (BoNT/B)': '#FF6F61', // Coral,
    'botulism (BoNT/E)': '#92A8D1', // Cool Blue
    'botulism (BoNT/F)': '#55B4B0', // Soft Turquoise
    'Foodborne botulism': '#88B04B', // Moss Green
    'foodborne botulism (BoNT/A)': '#F7CAC9', // Soft Pink
    '​​​​foodborne botulism (BoNT/AB)': '#955251', // Mauve Red
    'foodborne botulism (BoNT/B)': '#009B77', // Teal Green
    'foodborne botulism (BoNT/C)': '#DD4124', // Rust Red
    'foodborne botulism (BoNT/E)': '#45B8AC', // Aqua
    'foodborne botulism (BoNT/F)': '#EFC050', // Golden Yellow
    'Iatrogenic botulism': '#5B5EA6', // Indigo Blue
    'Infant botulism': '#9B2335', // Berry Red
    'infant botulism (BoNT/A)': '#DFCFBE', // Sand Beige
    'infant botulism (BoNT/B)': '#E15D44', // Brick Orange
    'infant botulism (BoNT/Ba)': '#7FCDCD', // Light Cyan
    'infant botulism (BoNT/Bf)': '#BC243C', // Deep Rose
    'infant botulism (BoNT/F)': '#98B4D4', // Periwinkle
    'Intestinal botulism': '#C3447A', // Pink Magenta
    'intestinal botulism (BoNT/A)': '#F4A460', // Sandy Brown
    'Wound botulism': '#4682B4', // Steel Blue
    'wound botulism (BoNT/A)': '#D2691E', // Chocolate Brown
    'wound botulism (BoNT/B)': '#FF4500', // Bright Orange
    clade: '#800080',
    confirmed: '#3CB371', // Medium Sea Green
    notSpecified: '#468499', // Cool Gray Blue
    suspected: '#FFD700', // Gold
  } as Record<string, string>,
  extra: [
    '#DC143C', // Crimson Red
    '#00CED1', // Dark Turquoise
    '#20B2AA', // Light Sea Green
    '#32CD32', // Lime Green
    '#8B4513', // Saddle Brown
    '#FF1493', // Deep Pink
    '#00FA9A', // Medium Spring Green
    '#9370DB', // Medium Purple
    '#DAA520', // Goldenrod
    '#C71585', // Medium Violet Red
    '#8A2BE2', // Blue Violet
  ],
}
